import { isUsingExcludedMid } from '../utils/excluded-mids';
import { useRuntimeConfig, useState, useRoute } from 'nuxt/app';

export function useOptimizelyState() {
  const config = useRuntimeConfig();
  const route = useRoute();
  const activeMid = useState('activeMid', () => '');
  const isExcludedMid = isUsingExcludedMid(activeMid.value);
  const userAgent = (useRequestHeader('user-agent') ?? '').toLowerCase();

  const optimizelyDisabled = Boolean(
    isExcludedMid ||
      route.query.disable_optimizely === 'true' ||
      config.public.DISABLE_OPTIMIZELY === 'true' ||
      userAgent.includes('tapp/ci') ||
      userAgent.includes('googlebot'),
  );

  const optimizelyWebDisabled = optimizelyDisabled || useFeatureFlag(`optimizely_web_enabled_${config.public.APPLICATION_ID}`) !== true;

  return {
    optimizelyDisabled,
    optimizelyWebDisabled,
  };
}
